<template>
  <v-row class="my-1 py-1 px-3" align="center">
    <v-col cols="12" md="5">
      <v-row class="flex-nowrap draggable" align="center">
        <v-icon class="">drag_indicator</v-icon>
        <span class="truncate mr-1 question-title font-weight-medium">{{ index + 1 }}. {{ question.question }}</span>
      </v-row>
    </v-col>
    <v-col cols="8" md="5">
      <v-row class="flex-nowrap" align="center">
        <v-chip v-if="question.category_name" small class="d-none d-md-flex">{{ question.category_name }}</v-chip>
        <difficulty  v-if="question.difficulty" :size="question.difficulty" />
        <span class="truncate mx-2 text--grey-darken-3">{{ answer}}</span>
      </v-row>
    </v-col>
    <v-col cols="4" md="2">
      <v-row justify="end">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small fab dark v-bind="attrs" color="#ED217C" v-on="on"
                   class="mx-1" @click="$emit('edit', question)"
            >
              <v-icon dark>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('pages.createGame.editQuestion') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small fab dark v-bind="attrs" color="danger" v-on="on"
                   class="mx-1" @click="$emit('delete',question)"
            >
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('pages.createGame.removeQuestion') }}</span>
        </v-tooltip>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";
import Difficulty from "src/view/gameQuestions/Difficulty";

export default {
  name: 'GameQuestionRow',
  components: { Difficulty },
  data() {
    return {
      questionTypes: QuestionType.getAsOption()
    }
  },
  props: {
    index: Number,
    question: {},
  },
  computed: {
    questionType() {
        return this.questionTypes[this.question.question_type - 1].text;
    },
    answer(){
      return this.question?.answer?.content;
    }

  }

}
</script>
<style scoped lang="scss">
.draggable {
  cursor: pointer;
}

.question-title {
  font-size: 1.15rem;
}

.truncate {
  white-space: nowrap; /* Ensures the text stays on one line */
  overflow: hidden; /* Hides overflowed text */
  text-overflow: ellipsis; /* Adds "..." at the end */
}

</style>
